<template>
    <div class="d-flex flex-column justify-center align-center"
        :class="($vuetify.breakpoint.mdAndUp) ? 'fill-height align-center ' : '0'">
        <v-card class="rounded-0 ma-0" :elevation="($vuetify.breakpoint.mdAndUp) ? '6' : '0'">
            <v-card flat class="rounded-0" color="primary" v-if="$vuetify.breakpoint.mdAndUp">
                <v-app-bar flat height="60" dark color="primary">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn class="mr-2" v-bind="attrs" @click="goToLogin" v-on="on" icon>
                                <v-icon>mdi-home-outline</v-icon>
                            </v-btn>
                        </template>
                        <span>Ir a Login</span>
                    </v-tooltip>
                    <v-toolbar-title>Cambiar contraseña</v-toolbar-title>
                </v-app-bar>
            </v-card>
            <v-card class="rounded-0" width="550" flat>
                <ValidationObserver ref="obs" v-slot="{ invalid }">
                    <v-form v-model="valid" @submit.prevent="cambiarPass">
                        <v-card-text class="mt-5">
                            <v-row class="d-flex flex-column">
                                <v-col cols="12" md="12">
                                    <v-alert border="left" class="rounded-0" colored-border dense color="orange"
                                        elevation="6">
                                        <div class="font-weight-bold orange--text text-h6">
                                            IMPORTANTE
                                        </div>
                                        <div class="font-weight-regular text-body-1">
                                            <v-icon color="orange">mdi-circle-small</v-icon>
                                            La contraseña debe contener al menos una letra mayúscula.
                                        </div>
                                        <div class="font-weight-regular text-body-1">
                                            <v-icon color="orange">mdi-circle-small</v-icon>
                                            La longitud total de la contraseña debe ser de al menos 8 caracteres.
                                        </div>
                                    </v-alert>
                                </v-col>
                                <v-col cols="12" md="12">
                                    <ValidationProvider rules="required|confirmed:confirmation" v-slot="v">
                                        <v-text-field outlined v-model="confirmation" :error-messages="v.errors[0]"
                                            :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                                            :type="show1 ? 'text' : 'password'" name="password" label="Contraseña"
                                            @click:append="show1 = !show1"></v-text-field>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="12">
                                    <ValidationProvider vid="confirmation" v-slot="v">
                                        <v-text-field outlined v-model="password"
                                            :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                                            :type="show2 ? 'text' : 'password'" :error-messages="v.errors[0]"
                                            label="Confirmar contraseña" class="input-group--focused"
                                            @click:append="show2 = !show2"></v-text-field>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="12">
                                    <v-btn :disabled="invalid" elevation="0" block class="pa-6" color="primary"
                                        type="cambiarPass">
                                        <v-icon class="mr-2">mdi-lock-check-outline</v-icon>
                                        Actualizar contraseña
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-form>
                </ValidationObserver>
            </v-card>
        </v-card>
    </div>
</template>


<script>

import { mapActions, mapGetters } from 'vuex';
import { ValidationProvider, ValidationObserver } from 'vee-validate';

export default {
    components: {

        ValidationObserver,
        ValidationProvider,
    },

    data() {
        return {
            hash: '',
            valid: false,
            show1: false,
            show2: false,
            password: '',
            confirmation: '',
        }
    },
    computed: {
        ...mapGetters('notificaciones', ['loading'])
    },

    created() {
        let uri = window.location.search.substring(1);
        console.log(uri)
        let params = new URLSearchParams(uri);
        this.hash = params.get('v')
        this.getValidation({ hash: this.hash })
    },
    methods: {
        ...mapActions('notificaciones', ['showSnack']),
        ...mapActions(['getValidation']),

        goToLogin() {
            this.$router.push('/Login').catch(() => { })
        },
        preventArrowKeys(event) {
            if (event.keyCode === 38 || event.keyCode === 40) {
                event.preventDefault();
            }
        },
        cambiarPass() {
            this.$refs.obs.validate().then(result => {
                if (result) {
                    this.getValidation({ hash: this.hash, pwd: this.password })
                } else {
                    console.log('Formulario inválido, no se puede enviar la petición');
                }
            });

        },
    },

}

</script>